module.exports = __webpack_public_path__ + "assets/img/image-not-found.d022ba9a.png";